import { Button, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APIS, URLS, SF_SVR_SRCH, SG_SVR_LIST } from "@/tra/tancis/ptli/ewc/svr/services/EwciSvrLstService";

/*
 * Server List
 * !== 서버 목록 ==!
 */
export const EWCI1001003Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015"],
    }); 
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const [namespaceList, setNamespaceList] = useState([]);
    const [sttsList, setSttsList] = useState([]);

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        svrSrch: useForm({
            defaultSchema: SF_SVR_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        svrList: useGrid({
            defaultSchema: SG_SVR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const code = [
        { label: "Pending", value: "Pending" },
        { label: "Running", value: "Running" },
        { label: "Succeeded", value: "Succeeded" },
        { label: "Failed", value: "Failed" },
        { label: "Unknown", value: "Unknown" },
        { label: "CrashLoopBackOff", value: "CrashLoopBackOff" },
        { label: "ContainerCreating", value: "ContainerCreating" },
        { label: "Terminating", value: "Terminating" },
        { label: "ImagePullBackOff", value: "ImagePullBackOff" },
        { label: "ErrImagePull", value: "ErrImagePull" },
    ];

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get the Server list. !== 서버 목록을 조회한다.==!
        getSvrList: useFetch({
            api: (page = grid.svrList.page) => {
                return APIS.getSvrList(form.svrSrch.getValues(), page, grid.svrList.size);
            },
            enabled: comnUtils.isEmpty(form.svrSrch.errors) && form.svrSrch.isSubmitted,
            key: [grid.svrList.page, grid.svrList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.svrSrch.getValues(),
                    page: grid.svrList.page,
                    size: grid.svrList.size,
                });
            },
        }),
        getAllNmspaceList: useFetch({
            api: () => {
                return APIS.getAllNmspaceList();
            },
            onSuccess: (data) => {
                setNamespaceList(data.namespaceList.content);
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getSvrList: (page: number = 0) => {
            form.svrSrch.handleSubmit(
                () => {
                    grid.svrList.setPage(page);
                    fetch.getSvrList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        getAllNmspaceList: () => {
            fetch.getAllNmspaceList.fetch();
        },
    };

    const render = {
        cell: {
            name: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ewci1001004q}/${rowValues.namespace}/${rowValues.name}`}>{value}</Link>;
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getSvrList();
        handler.getAllNmspaceList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.svrSrch.schema.namespace} options={namespaceList}></Group.Control>
                            <Group.Control {...form.svrSrch.schema.name} options={namespaceList}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.svrSrch.schema.status} options={code}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.svrSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getSvrList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.svrList.grid} data={fetch.getSvrList.data?.svrList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
